import axios from 'axios';
import { notifications } from '@mantine/notifications';
import { useAuthStore } from '../store/authStore';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '5000'),
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Request interceptor to attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor to handle 401 and other errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const response = await axios.post(`${axiosInstance.defaults.baseURL}/auth/guest`, undefined, {
            timeout: axiosInstance.defaults.timeout,
          });
          localStorage.setItem('token', response.data.token);
          useAuthStore.getState().setUser(response.data.user);

          const newToken = localStorage.getItem('token');
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axiosInstance(originalRequest); // retry the original request
          }
        } catch (retryError) {
          notifications.show({
            title: 'Guest Login Failed',
            message: 'Could not log in as guest. Please sign in manually.',
            color: 'red',
          });
        }
      }

      // Handle other server errors
      notifications.show({
        title: 'Error',
        message: error.response.data?.message || `Error ${error.response.status}`,
        color: 'red',
      });
    } else {
      notifications.show({
        title: 'Network Error',
        message: 'Could not connect to the server.',
        color: 'red',
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
